export const REASON_CODES = {
    BELL: 36,
    CONTRACTOR: 37,
    ENVIRONMENT: 38,
    OTHER: 39,
};

export const BELL_SUBREASON_CODES = {
    BELL_REQUESTED: 40,
    TIE_LOCATES_REQUIRED: 42,
    BELL_CAUSED_MISSING_INCORRECT_INFO: 45,
};

export const CONTRACTOR_SUBREASON_CODES = {
    CONTRACTOR_LOAD_MANAGEMENT: 47,
    CONRACTOR_ADMIN_MANAGAEMENT: 48,
    DD_5_PAST_DUE_DATE: 49,
};

export const ENVIRONMENT_SUBREASON_CODES = {
    WINTER_FREEZE_UP: 50,
    WEATHER_CONDITIONS: 51,
    NO_ACCESS_TO_JOB_SITE: 52,
    WORK_SITE_UNSAFE: 53,
};

export const OTHER_SUBREASON_CODES = {
    WAITING_ON_LOCATES: 54,
    NON_BUSINESS_DAY_DUE_DATE: 55,
    ADDITIONAL_WORK_REQUIRED: 56,
    PRE_WORK_REQUIRED: 57,
    WAITING_ON_PERMITS: 58,
    CUSTOMER_REQUESTED_NEW_DATE: 59,
    THIRD_PARTY_REQUESTED: 60,
    OTHER_CAUSE: 61,
};
